var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root",on:{"click":function($event){return _vm.save()}}},[_c('v-stage',{ref:"windRoseArea",attrs:{"config":{ width: 150, height: 150, draggable: false }}},[_c('v-layer',[_c('url-image',{attrs:{"imageUrl":"/compas.png","config":{
          rotation: _vm.windRose.rotation,
          x: 80,
          y: 80,
          width: 130,
          height: 130,
          offsetX: 65,
          offsetY: 65,
          draggable: true,
          dragBoundFunc: function dragBoundFunc(pos) {
            _vm.windRoseRotate(_vm.getScaledPointerPosition().x, _vm.getScaledPointerPosition().y);
            return {
              x: 80,
              y: 80,
            };
          },
        }}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }